import { TestErrorPage } from '@skytech/monitoring'
import { Route, Routes } from 'react-router-dom'

import { useRoutes } from './useRoutes'

export const AuthenticatedRoutes = () => {
  const routes = useRoutes()
  return (
    <Routes>
      {/* For testing monitoring error reports */}
      {process.env.VERCEL_ENV !== 'production' && (
        <Route path="/monitoring" element={<TestErrorPage />} />
      )}
      {routes.map(route => (
        <Route key={route.path} path={route.path} element={route.element} />
      ))}
    </Routes>
  )
}
